'use strict';

function initNativeDialogs(root = document) {
  if (!root || typeof root.querySelectorAll !== 'function') {
    return;
  }

  root.querySelectorAll('[data-dialog-target]').forEach((trigger) => {
    const dialogId = trigger.dataset.dialogTarget;
    const dialog = document.getElementById(dialogId);

    if (!dialog || typeof dialog.showModal !== 'function') {
      return;
    }

    const handleClick = () => {
      if (dialog.open) {
        return;
      }

      const closeOnOutsideClick = (event) => {
        if (event.target === dialog) {
          dialog.close();
        }
      };

      const handleClose = () => {
        dialog.removeEventListener('click', closeOnOutsideClick);
        dialog.removeEventListener('close', handleClose);
      };

      dialog.addEventListener('click', closeOnOutsideClick);
      dialog.addEventListener('close', handleClose);
      dialog.showModal();
    };

    trigger.addEventListener('click', handleClick);
  });
}

module.exports = {
  initNativeDialogs,
};
